import graphql__e5d9092d052fee4aaaa2 from "./__generated__/MapUsersListUser_usersMapUser.graphql.js";import { useContext, useRef, useEffect, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import classNames from "classnames";

import UserAvatar from "../../Users/UserAvatar";
import UserGroups from "../../Users/UserGroups";
import UserAuthorName from "../../Users/UserAuthorName";
import { isResourcesListItemSelected } from "../../Utils/resourcesList";
import { MapPanelSizingContext } from "../MapPanel/withMapPanelSizing";

import { selectItem, unselectItem } from "../../../reducers/resourcesList/selection";
import {
  RESOURCES_LIST_USER_TYPE,
  useResourcesList
} from "../../ResourcesList/resourcesList";
import ButtonDiv from "../../Buttons/ButtonDiv";

const MapUsersListUser = props => {
  const usersMapUser = useFragment(MapUsersListUser_usersMapUser, props.usersMapUser);
  const { user, profileFields } = usersMapUser;

  const { resourcesListKey, ...resourcesList } = useResourcesList();
  const isSelected = isResourcesListItemSelected(resourcesList, {
    id: user.id,
    type: RESOURCES_LIST_USER_TYPE
  });

  const { scrollPanelTo } = useContext(MapPanelSizingContext);
  const wasSelectedRef = useRef();
  const containerRef = useRef();

  const wasSelected = wasSelectedRef.current;

  const dispatch = useDispatch();
  const handleItemClicked = useCallback(() => {
    if (isSelected) {
      dispatch(unselectItem(resourcesListKey));
    } else {
      dispatch(selectItem(resourcesListKey, user.id, RESOURCES_LIST_USER_TYPE));
    }
  }, [dispatch, isSelected, resourcesListKey, user.id]);

  useEffect(() => {
    // Only run if the user is newly selected and we have the container
    if (!scrollPanelTo || wasSelected || !isSelected || !containerRef.current) {
      return;
    }

    scrollPanelTo(containerRef.current);
  }, [wasSelected, isSelected, containerRef, scrollPanelTo]);

  wasSelectedRef.current = isSelected;

  const className = classNames([
    "box",
    "map-users-list-user",
    "border-primary",
    {
      open: isSelected
    }
  ]);

  return (
    <div className={className} ref={containerRef}>
      <ButtonDiv
        className="padding-sm d-flex box-shadow btn-unstyled"
        onClick={handleItemClicked}
        aria-expanded={isSelected}
      >
        <UserAvatar className="contribution-author-avatar" user={user} size={35} />

        <div className="flex-1">
          <UserAuthorName user={user} ContainerComponent="h3" />

          <div className="user-groups">
            <UserGroups user={user} />
          </div>
        </div>
      </ButtonDiv>

      {isSelected && profileFields.length > 0 && (
        <div className="user-details padding-sm ">
          {profileFields.map(profileField => (
            <div key={profileField.id} className="user-details-profile-field">
              <b>{profileField.name} : </b>
              {profileField.value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const MapUsersListUser_usersMapUser = graphql__e5d9092d052fee4aaaa2;

export default MapUsersListUser;
